"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _reactSizeme = require("react-sizeme");

var _Flex = _interopRequireDefault(require("../../Flex/Flex"));

var _MotionFlex = _interopRequireDefault(require("../../motionComponents/MotionFlex/MotionFlex"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

var _excluded = ["id", "label", "disabled", "onChange", "height", "width", "borderRadius", "labelStyling", "value", "trackballSize", "trackStylingUnActive", "trackStylingActive", "trackBallStylingUnActive", "trackBallStylingActive"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HiddenCheckbox = _styledComponents["default"].input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "MotionToggle__HiddenCheckbox",
  componentId: "sc-2cxleo-0"
})(["", ""], (0, _polished.hideVisually)());
/**
 * A toggle input animated with Framer Motion.
 *
 * This component has the ability to automatically scale to desired width and height.
 *
 * To learn more about how to use this component, see examples within Storybook.
 *
 * @param {object} props React components passed in props
 * @param {string} [props.id] ID for input

 * @param {string} [props.label] Text label that goes on right side of toggle
 * @param {boolean} [props.disabled] Disables input
 * @param {function} [props.onChange] Function that is called on toggle
 * @param {number | string} [props.height] Height of toggle
 * @param {number | string} [props.width] Sets width of toggle
 * @param {object} [props.labelStyling] Styling for label
 * @param {object} [props.trackStylingUnActive] Styling for track when toggle = false
 * @param {object} [props.trackStylingActive] Styling for track when toggle = true
 * @param {object} [props.trackBallStylingUnActive] Styling for track ball when toggle = false
 * @param {object} [props.trackBallStylingActive] Styling for track ball when toggle = true
 * @param {number} [props.trackballSize] Override size of trackball
 * @param {boolean} [props.value] Value of toggle. When externally updates, forces internal state of toggle
 * @param {object} [props.borderRadius] Override track border radius
 */


var MotionToggle = function MotionToggle(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function (_boolean) {
    return _boolean;
  } : _ref$onChange,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 40 : _ref$width,
      borderRadius = _ref.borderRadius,
      _ref$labelStyling = _ref.labelStyling,
      labelStyling = _ref$labelStyling === void 0 ? {} : _ref$labelStyling,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? false : _ref$value,
      trackballSize = _ref.trackballSize,
      _ref$trackStylingUnAc = _ref.trackStylingUnActive,
      trackStylingUnActive = _ref$trackStylingUnAc === void 0 ? {
    backgroundColor: "#E9E9E9"
  } : _ref$trackStylingUnAc,
      _ref$trackStylingActi = _ref.trackStylingActive,
      trackStylingActive = _ref$trackStylingActi === void 0 ? {
    backgroundColor: "#C5D9E9"
  } : _ref$trackStylingActi,
      _ref$trackBallStyling = _ref.trackBallStylingUnActive,
      trackBallStylingUnActive = _ref$trackBallStyling === void 0 ? {
    backgroundColor: "#929292"
  } : _ref$trackBallStyling,
      _ref$trackBallStyling2 = _ref.trackBallStylingActive,
      trackBallStylingActive = _ref$trackBallStyling2 === void 0 ? {
    backgroundColor: "#4E7493"
  } : _ref$trackBallStyling2,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(value),
      isToggledLocal = _useState[0],
      setIsToggledLocal = _useState[1];

  (0, _react.useEffect)(function () {
    setIsToggledLocal(value);
  }, [value]);
  var trackballSizeLocal = trackballSize || height - height / 100 * 30;
  var padding = (height - trackballSizeLocal) / 2;
  var trackBallVariants = {
    unActive: (0, _extends2["default"])({
      marginLeft: 0
    }, trackBallStylingUnActive),
    active: function active(_ref2) {
      var ballSize = _ref2.ballSize,
          trackSize = _ref2.trackSize;
      return (0, _extends2["default"])({
        marginLeft: trackSize.width - ballSize.width - padding * 2 || 0
      }, trackBallStylingActive);
    }
  };
  var trackVariants = {
    unActive: (0, _extends2["default"])({}, trackStylingUnActive),
    active: (0, _extends2["default"])({}, trackStylingActive)
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(HiddenCheckbox, {
    id: id,
    checked: isToggledLocal,
    disabled: disabled,
    onChange: function onChange(e) {
      setIsToggledLocal(e);
    },
    "aria-hidden": true,
    tabIndex: -1
  }), /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    className: "toggle-input-container",
    width: "auto",
    alignItems: "center",
    tabIndex: 0,
    "data-switch": true,
    id: "toggleLabel-" + id,
    role: "switch",
    "aria-readonly": disabled,
    "aria-checked": isToggledLocal,
    "aria-labelledby": label ? "toggleLabel-" + id : "",
    "aria-label": "Switch",
    "aria-disabled": disabled,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" && !disabled) {
        onChange(!isToggledLocal);
        setIsToggledLocal(!isToggledLocal);
      }
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
    className: "toggle-input-track",
    variants: trackVariants,
    initial: isToggledLocal ? "active" : "unActive",
    animate: isToggledLocal ? "active" : "unActive",
    width: width,
    onTap: function onTap() {
      if (!disabled) {
        onChange(!isToggledLocal);
        setIsToggledLocal(!isToggledLocal);
      }
    },
    height: height,
    style: {
      cursor: disabled ? "no-drop" : "pointer"
    },
    borderRadius: borderRadius || height / 2,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_reactSizeme.SizeMe, null, function (_ref3) {
    var trackSize = _ref3.size;
    return /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
      width: "100%",
      height: "100%",
      p: padding + "px",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_reactSizeme.SizeMe, null, function (_ref4) {
      var ballSize = _ref4.size;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], {
        variants: trackBallVariants,
        initial: isToggledLocal ? "active" : "unActive",
        animate: isToggledLocal ? "active" : "unActive",
        custom: {
          ballSize: ballSize,
          trackSize: trackSize
        },
        className: "toggle-input-trackball",
        height: trackballSizeLocal,
        width: trackballSizeLocal,
        minWidth: trackballSizeLocal,
        minHeight: trackballSizeLocal,
        transition: {
          ease: "easeInOut",
          duration: 0.2
        },
        borderRadius: trackballSizeLocal
      }));
    }));
  })), label && /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    ml: 2
  }, /*#__PURE__*/_react["default"].createElement("label", {
    style: {
      display: "none"
    },
    htmlFor: "toggleLabel-" + id
  }, label), /*#__PURE__*/_react["default"].createElement(_Text["default"], labelStyling, label))));
};

var _default = MotionToggle;
exports["default"] = _default;